import { HashAlgorithm } from '@scayle/storefront-nuxt'
import { colorId } from './colors'
import type { SortingValueKey } from '~/utils/sort'

export const defaultConfigs = {
  appKeys: {
    wishlistKey: 'aboutyou_customer_{userId}',
    basketKey: 'aboutyou_customer_{userId}',
    hashAlgorithm: HashAlgorithm.SHA256,
  },
}

export const colorConfig = {
  colorId,
}

export const DEFAULT_SORT_VALUE_KEY: SortingValueKey = 'topSeller'
